import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'swb-slides',
  templateUrl: './slides.component.html'
})
export class SlidesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
